<template>
    <v-dialog v-model="dialog" max-width="80%">
        <app-card>
            <app-section-loader :status="loading.submit"></app-section-loader>
            <h4>THÊM PHÒNG CHO INTERNET</h4>
            <p class="fs-14 grey--text">Thêm phòng cho {{ internet_user.user }}</p>
            <v-form ref="form">
                <v-container fluid>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md3>
                            <v-select label="Tòa nhà" :disabled="loading.submit" v-model="form.building"
                                :items="list_building" prepend-icon="domain" :rules="[rules.required]"
                                required></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-autocomplete label="Số phòng" :disabled="loading.submit" v-model="form.room_id"
                                :items="room_ids" item-text="room_id" item-value="room_id" prepend-icon="meeting_room"
                                :rules="[rules.required]" required></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Tên user" :disabled="true" v-model="internet_user.user"
                                prepend-icon="account_box"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-text-field label="Giá gói cước" :disabled="loading.submit" v-model="form.price"
                                prepend-icon="money" :rules="[rules.required]" v-currency disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Tên gói cước" :disabled="loading.submit" v-model="form.package_name"
                                prepend-icon="label" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Tốc độ (Mbps)" :disabled="loading.submit" v-model="form.speed_mbps"
                                prepend-icon="speed" type="number" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Số người ở" :disabled="loading.submit"
                                v-model="form.number_of_residents" prepend-icon="people" type="number"
                                :rules="[rules.required]"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Số chứng từ giấy" :disabled="loading.submit" v-model="form.receipt_code"
                                prepend-icon="receipt"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Mã chứng từ" :disabled="true" v-model="form.receipt_id"
                                prepend-icon="receipt_long"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Tên wifi" :disabled="loading.submit" v-model="form.wifi_name"
                                prepend-icon="wifi" required :rules="[rules.required]"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Password Wifi" :disabled="loading.submit" v-model="form.wifi_password"
                                prepend-icon="lock" required :rules="[rules.required]"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-menu :close-on-content-click="false" v-model="menu_date_start" :nudge-right="40" lazy
                                transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="form.date_start" label="Ngày thực tế lắp"
                                    :disabled="loading.submit" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker locale="vi-VI" v-model="form.date_start"
                                    @input="menu_date_start = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-text-field label="Giá thu KH" :disabled="loading.submit" v-model="form.customer_price"
                                prepend-icon="money" v-currency></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-textarea label="Ghi chú" :disabled="loading.submit" v-model="form.note"
                                prepend-icon="note" rows="3"></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="loading.submit" @click="cancelInput">
                        Trở về
                    </v-btn>
                    <v-btn :loading="loading.submit" :disabled="loading.submit" @click="submit" color="green" dark>
                        Thêm Phòng
                    </v-btn>
                </v-card-actions>
            </v-form>
        </app-card>
    </v-dialog>
</template>
<script>
import api from "Api";
import { list_building, WIFI_TYPES } from 'Constants/db-config';
import { parseCurrency } from "Helpers";
import moment from 'moment';
const basements = [
    { room_id: 'tang-ham-gb', building: "GB" },
    { room_id: 'tang-ham-tt', building: "TT" },
    { room_id: 'tang-ham-ma', building: "MA" },
    { room_id: 'tang-ham-xa', building: "XA" },
    { room_id: 'tang-ham-bn', building: "BN" },
    { room_id: 'Camera Gia Bảo', building: "GB" },
    { room_id: 'Camera Thanh Tâm', building: "TT" },
    { room_id: 'Camera Mai Anh', building: "MA" },
    { room_id: 'Camera Xuân Anh', building: "XA" },
    { room_id: 'Camera Minh Tâm', building: "MT" },
    { room_id: 'Camera Bảo Ngọc', building: "BN" },
]

export default {
    name: "add-room-dialog",
    props: {
        dialog: Boolean,
        internet_user: Object
    },
    data() {
        return {
            menu_date_start: false,
            rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            form: {
                building: '',
                room_id: '',
                price: '',
                date_start: '',
                wifi_name: '',
                wifi_password: '',
                speed_mbps: '',
                package_name: '',
                number_of_residents: '',
                note: '',
                receipt_code: '',
                receipt_id: '',
                customer_price: '',
            },
            list_building,
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            loading: {
                submit: false
            },
        }
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms.concat(basements)
        },
        room_ids() {
            return this.rooms.filter(room => room.building === this.form.building)
        },
    },
    watch: {
        dialog(nv) {
            if (nv) {
                this.form.building = this.internet_user.building || '';
                this.form.room_id = this.internet_user.room_id || '';
                this.form.price = this.internet_user.price || '';
                this.form.speed_mbps = this.internet_user.speed_mbps || '';
                this.form.package_name = this.internet_user.package_name || '';
                this.form.number_of_residents = this.internet_user.number_of_residents || 1;
                this.form.wifi_name = this.internet_user.wifi_name || '';
                this.form.wifi_password = this.internet_user.wifi_password || '';
                this.form.date_start = moment().format('YYYY-MM-DD');
                this.form.user = this.internet_user.user || '';
                this.form.customer_price = this.internet_user.customer_price || this.internet_user.price || '';
                
                this.form.receipt_code = this.internet_user.receipt_code || '';
                this.form.receipt_id = this.internet_user.receipt_id || '';
            } else {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
            }
        },
        "form.receipt_code"(nv) {
            if (nv && this.form.building) {
                const buildingCode = this.form.building === 'MT' ? 'MA' : this.form.building;
                this.form.receipt_id = buildingCode + '.' + nv + ".MA";
            }
        },
        "form.building"(nv) {
            if (nv && this.form.receipt_code) {
                const buildingCode = nv === 'MT' ? 'MA' : nv;
                this.form.receipt_id = buildingCode + '.' + this.form.receipt_code + ".MA";
            }
        },
    },
    methods: {

        cancelInput() {
            this.$emit('changeDialogState', false);
        },
        async submit() {
            try {
                if (!this.$refs.form.validate()) {
                    swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                    return
                }
                const postData = {
                    room_id: this.form.room_id,
                    building: this.form.building,
                    date_start: this.form.date_start,
                    wifi_name: this.form.wifi_name,
                    wifi_password: this.form.wifi_password,
                    price: parseCurrency(this.form.price, "vi-VN", 'VND'),
                    speed_mbps: this.form.speed_mbps ? Number(this.form.speed_mbps) : null,
                    package_name: this.form.package_name || '',
                    number_of_residents: this.form.number_of_residents ? Number(this.form.number_of_residents) : 1,
                    note: this.form.note || '',
                    wifi_type: WIFI_TYPES.AUXILIARY,
                    receipt_code: this.form.receipt_code,
                    receipt_id: this.form.receipt_id,
                    user: this.internet_user.user || '',
                    customer_price: this.form.customer_price ? parseCurrency(this.form.customer_price, "vi-VN", 'VND') : null,
                }
                this.loading.submit = true;
                const data = await api.createInternet(postData)
                this.loading.submit = false;

                if (data.status === 200) {
                    this.$emit('changeDialogState', false);
                    swal.fire('Thành công', data.data.message, 'success');
                    this.$emit('reloadTable');
                } else {
                    swal.fire('Lỗi', data.message || 'Có lỗi xảy ra', 'error');
                }
            } catch (error) {
                console.error("AddRoom submit error:", error);
                this.loading.submit = false;
                swal.fire('Lỗi', 'Có lỗi xảy ra khi thêm phòng', 'error');
            }
        }
    }
}
</script>